import label from "@/lang/StaticLabels.js";

// PAFTERSALES Router  - خدمات پس از فروش -----------------------------------------------
let routeItems = {
  path: "PAFTERSALES",
  name: "PAFTERSALES",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  redirect: { name: "PAFTERSALESDashboard" },
  children: [
    {
      path: "dashboard",
      name: "PAFTERSALESDashboard",
      redirect: { name: "PAFTERSALESServiceSupportList" },
    },

    // Operation  -----------------------------------------------
    {
      path: "serviceSupports",
      name: "PAFTERSALESServiceSupportList",
      meta: {
        label: label.page.serviceSupports,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/phamyar/operation/serviceSupport"),
    },
  ],
};

export default routeItems;
